export const DEFAULT_MTU = 156;
export const CONNECTION_LOST_DELAY = 2e3; // 2s;
export const BLE_DISCONNECT_TIMEOUT_ANDROID = 15e3; // 15s;
export const BLE_DISCONNECT_TIMEOUT_IOS = 10e3; // 10s;
